'use client';

import OrderStepProvider from '@/providers/OrderStepContext';
import type { FC } from 'react';
import { Suspense } from 'react';

import Form, { type FormProps } from './form';

const FormWrapper: FC<FormProps> = ({
  formTrackingId,
  formSourceStoryUuid,
  blok,
  embedded = true,
  onSuccess,
  trackFormPurchase = false,
  headline,
}) => {
  return (
    <OrderStepProvider>
      <Suspense>
        <Form
          formTrackingId={formTrackingId}
          formSourceStoryUuid={formSourceStoryUuid}
          blok={blok}
          embedded={embedded}
          onSuccess={onSuccess}
          trackFormPurchase={trackFormPurchase}
          headline={headline}
        />
      </Suspense>
    </OrderStepProvider>
  );
};

export default FormWrapper;
